import React from 'react';
import { Navigate } from 'react-router-dom';
import { useRsvp } from '../context/RsvpContext';

/**
 * This component handles the initial routing logic for the application.
 * It checks the authentication status and redirects the user to the appropriate
 * entry point: `/code-gate` for unauthenticated users or `/home` for authenticated ones.
 * This avoids a double-redirect scenario.
 */
const RootRedirector: React.FC = () => {
    const { rsvp, isLoading } = useRsvp();

    if (isLoading) {
        // Render nothing while checking for an active session to prevent premature redirects.
        return null;
    }

    return rsvp ? <Navigate to="/home" replace /> : <Navigate to="/code-gate" replace />;
};

export default RootRedirector;